import React, { useEffect, useRef } from "react";
import { KINDS, castMember } from "../../video/toon/cast";
import { neutralPose, poseAt } from "../../video/toon/rig";
import { drawCharacter } from "../../video/toon/toon2d";

// A small picture of a character (idle, smiling) for the cast list.
export default function CharacterThumb({ member, index = 0, size = 96, talking = false }) {
  const ref = useRef(null);
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const ch = castMember(member, index);
    const w = canvas.width;
    const h = canvas.height;
    const g = ctx.createLinearGradient(0, 0, 0, h);
    g.addColorStop(0, "#1c3a5c");
    g.addColorStop(1, "#0d2038");
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, w, h);
    if (ch.kind === "narrator") {                                        // a voice only: a microphone
      ctx.fillStyle = "#9fb3c8";
      ctx.beginPath(); ctx.roundRect ? ctx.roundRect(w * 0.4, h * 0.25, w * 0.2, h * 0.28, w * 0.1) : ctx.rect(w * 0.4, h * 0.25, w * 0.2, h * 0.28); ctx.fill();
      ctx.strokeStyle = "#9fb3c8"; ctx.lineWidth = w * 0.035; ctx.lineCap = "round";
      ctx.beginPath(); ctx.arc(w / 2, h * 0.45, w * 0.18, 0.1 * Math.PI, 0.9 * Math.PI); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(w / 2, h * 0.63); ctx.lineTo(w / 2, h * 0.75); ctx.moveTo(w * 0.38, h * 0.75); ctx.lineTo(w * 0.62, h * 0.75); ctx.stroke();
      return;
    }
    const s = (h / 8.2) * Math.pow(KINDS[ch.kind].scale, 0.5);
    ctx.save();
    ctx.translate(w / 2, h * 0.93);
    ctx.scale(s, s);
    const pose = talking ? poseAt("talk", 0.4, { energy: 0.6, nod: 0.3 }, 0, "happy", index) : { ...neutralPose(), smile: 0.5 };
    drawCharacter(ctx, ch, { blink: 0, open: talking ? 0.5 : 0, wide: 0, round: 0 }, pose, 0);
    ctx.restore();
  }, [member, index, talking]);
  return <canvas ref={ref} width={size * 2} height={size * 2.4} style={{ width: size, height: size * 1.2 }} className="rounded-lg block" aria-hidden="true" />;
}
